import "./index.css";
import React, { useEffect, useState } from "react";
import MercClientHub from "./components/MercClientHub";
import NewsStoryOne from "./components/NewsStoryOne";
import NewsStoryTwo from "./components/NewsStoryTwo";
import Error from "./components/Error";
import Home from "./Home";

function App() {
  const [componentToShow, setComponentToShow] = useState(<Home />);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    
    // Check for the query parameter and set the component accordingly
    if (params.has("client-information-hub")) {
      setComponentToShow(<MercClientHub />);
    } else if (params.has("post-office-scandal-and-emissions")) {
      setComponentToShow(<NewsStoryOne />);
    } else if (params.has("the-emissions-scandal-the-journey-so-far")) {
      setComponentToShow(<NewsStoryTwo />);
    } else if (params.has("404")) {
      setComponentToShow(<Error />);
    } else {
      setComponentToShow(<Home />);
    }
  }, []); // Empty dependency array to run once on mount

  return (
    <div>
      {componentToShow}
    </div>
  );
}

export default App;
